/** @flow */
import React from 'react'
import { MUIButton } from 'app/components/Form'
import { styled } from '@mui/material'

const CustomButton = styled(
  MUIButton,
  {},
)<any>(() => ({
  variants: [
    {
      props: (props) => props,
      style: ({ bgColor }) => ({
        '&.MuiButton-root': {
          boxShadow: 'none',
          marginLeft: 5,
          borderRadius: '3px 3px 0 0',
          backgroundColor: bgColor,
          color: bgColor ? '#ffffff' : 'grey',
        },
        '&:hover': {
          boxShadow: '0 0 30px rgba(0, 0, 0, 0.1) inset',
          backgroundColor: bgColor || 'initial',
        },
        '& .Mui-disabled': {
          color: '#ffffff',
        },
      }),
    },
  ],
}))

export function WikiEditorButton({ bgColor, label, children, ...rest }: *): React$Element<any> {
  return (
    <CustomButton bgColor={bgColor} {...rest} variant="text">
      {label || children}
    </CustomButton>
  )
}
